import React, { lazy } from 'react';
import { Route, Switch, Redirect, HashRouter } from 'react-router-dom';

// project imports
import MainLayout from './../layout/MainLayout';
import Loadable from '../ui-component/Loadable';
import cookie from "react-cookies";

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard')));
// Bookings
const Bookings = Loadable(lazy(() => import('../views/Bookings/booking')));
//Users
const Users = Loadable(lazy(() => import('../views/Users/users')));

//meetingRooms
const MeetingRooms = Loadable(lazy(() => import('../views/MeetingRooms/meetingRoom')));
const AddMeetingRoom = Loadable(lazy(() => import('../views/MeetingRooms/AddMeetingRoom')));

const Amenities = Loadable(lazy(() => import('../views/Amenities/amenities')));

const Cities = Loadable(lazy(() => import('../views/Cities/cities')));
//Branches
const Branches = Loadable(lazy(() => import('../views/Branches/branches')));
const AddBranch = Loadable(lazy(() => import('../views/Branches/AddBranch')));

//Manager 
const Manager = Loadable(lazy(() => import('../views/Manager/index')));
//Page not found
const PageNotFound = Loadable(lazy(() => import('../views/pagenotFound')))
const Type = cookie.load("type");

// sample page routing

//-----------------------|| MAIN ROUTING ||-----------------------//

const MainRoutes = () => {
    return (
        <HashRouter>
            <MainLayout>
                {Number(Type) === Number(1) && Type !== undefined && Type !== null ? (
                    <Switch>
                        <Route path="/login">
                            <Redirect to="/dashboard" />
                        </Route>
                        <Route path="/dashboard" exact component={DashboardDefault} />
                        <Route path="/bookings" exact component={Bookings} />
                        <Route path="/users" exact component={Users} />
                        <Route path="/branches" exact component={Branches} />
                        <Route path="/branches/:branchid" exact component={AddBranch} />
                        <Route path="/cities" exact component={Cities} />
                        <Route path="/amenities" exact component={Amenities} />
                        <Route path="/meetingRooms" exact component={MeetingRooms} />
                        <Route path="/addMeetingRoom" exact component={AddMeetingRoom} />
                        <Route path="/managers" exact component={Manager} />
                        {/* <Route path="**" exact>
                            <Redirect to="/dashboard" />
                        </Route> */}
                        <Route component={PageNotFound} />

                    </Switch>

                ) : (

                    <Switch>
                        <Route path="/login">
                            <Redirect to="/bookings" />
                        </Route>
                        <Route path="/bookings" exact component={Bookings} />
                        {/* <Route path="**" exact>
                            <Redirect to="/bookings" />
                        </Route> */}
                        <Route component={PageNotFound} />
                    </Switch>

                )}
            </MainLayout>
        </HashRouter>
    );
};

export default MainRoutes;
